// extracted by mini-css-extract-plugin
module.exports = {"modal-wrapper":"ModalShare_modal-wrapper_1QL0P","modalClose":"ModalShare_modalClose_3AhAl"};